// Alertadenegado.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function Alertadenegado({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningAmberIcon color="error" fontSize="large" />
          <Typography variant="h5" fontWeight="bold" color="error">
            ACCESO DENEGADO
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1">
          Por razones de seguridad, el acceso ha sido restringido.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="error">
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}
